import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-bet-slip-modal',
  templateUrl: './bet-slip-proceed-modal.component.html',
  styleUrls: ['./bet-slip-proceed-modal.component.scss'],
})
export class BetSlipProceedModalComponent implements OnInit {

  constructor(public modalCtrl:ModalController ) { }

  ngOnInit() {}

  dismiss() {
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }

}
